import { Component, Prop, h } from '@stencil/core';

import { actionItems } from '../types';

import { generateTimeArray } from './utils';

@Component({
  tag: 'time-select',
  styleUrl: 'time-select.css',
})
export class TimeSelect {
  @Prop() start = 10;
  @Prop() end = 18;
  @Prop() timeAvailability = [];
  @Prop() minutesInterval = 30;
  @Prop() selectedTime: string = '';
  @Prop() actions: actionItems = undefined;

  private values: { am: string[]; pm: string[] } = { am: [], pm: [] };

  componentWillRender() {
    const { start, end, minutesInterval } = this;
    const timeGroup = generateTimeArray({ start, end, minutesInterval });

    this.values = {
      am: timeGroup.filter((t) => t.includes('AM')),
      pm: timeGroup.filter((t) => t.includes('PM')),
    };
  }

  onTimeChanged = (time: string): void => {
    if (this.actions) {
      this.actions.timeChanged(time);
    }
  };

  renderTime = (time: string) => (
    <input
      type="button"
      value={time}
      class={{
        'font-open-sans rounded active:shadow-button outline:none xs:px-0 xs:py-1 xs:text-xs md:px-2 md:py-1.5 md:text-sm': true,
        'bg-clrs-kbb-darkbrightblue text-clrs-white border-none': time === this.selectedTime,
        'bg-clrs-white text-clrs-dark-grey border-solid border border-clrs-grey': time !== this.selectedTime,
      }}
      onClick={() => this.onTimeChanged(time)}
    />
  );

  render() {
    return (
      <div class="font-open-sans">
        {this.values.am.length ? (
          <div>
            <div class="text-clrs-grey mb-1">AM</div>
            <div class="grid grid-cols-4 gap-2">{this.values.am.map(this.renderTime)}</div>
          </div>
        ) : null}
        {this.values.pm.length ? (
          <div>
            <div class="text-clrs-grey mt-2 mb-1">PM</div>
            <div class="grid grid-cols-4 gap-2">{this.values.pm.map(this.renderTime)}</div>
          </div>
        ) : null}
      </div>
    );
  }
}
